import React from "react";
import { Grid, Container } from "@mui/material";
import { getRowData } from "gatsby-frontend";
import { Blocks } from "./../../";
import { useTheme } from "@mui/material/styles";

function Row(entity) {
	const theme = useTheme();
	const row_data = getRowData(entity);
	let spacing;
	if (entity.attributes && entity.attributes.field_spacing) {
		spacing = entity.attributes.field_spacing;
	} else {
		spacing = entity.fullWidth && !entity.centered ? 0 : 3;
	}
	function Wrapper({ centered, children }) {
		return centered ? (
			<Container
				maxWidth={theme?.customOptions?.containerMaxWidth || "xl"}
				sx={(theme) => ({
					...(entity.fullWidth && {
						marginTop: theme.spacing(3),
						marginBottom: theme.spacing(3),
					}),
				})}
			>
				{children}
			</Container>
		) : (
			<>{children}</>
		);
	}

	return (
		<Wrapper centered={entity.centered}>
			<Grid container spacing={spacing}>
				{row_data.cols.map((col, i) => (
					<Grid item xs={row_data.widths[i]} key={`col-${entity.id}-${i}`}>
						<Blocks data={col} className="column-section" />
					</Grid>
				))}
			</Grid>
		</Wrapper>
	);
}

export default Row;
